import { Dispatch, SetStateAction } from 'react'
import { fetchWithBaseUrl } from '../../utils/api'

export const getAuthUserProductAndPayment = async (
	teamId: string,
	productId: string,
	setUserProductAndPaymentDTO: Dispatch<SetStateAction<any | undefined>>,
	token?: string
) => {
	const urlSearchParams = new URLSearchParams(window.location.search)
	const params = Object.fromEntries(urlSearchParams.entries())
	if (params.paymentId) {
		if (localStorage.getItem('isPurchaseConfirmationVisible')) {
			alert('Megvásárolt jegyed elküldtük emailben.')
			localStorage.removeItem('isPurchaseConfirmationVisible')
		}
	}
	let query = `?teamId=${teamId}&productId=${productId}`
	if (params.paymentId) {
		query = query + `&paymentId=${params.paymentId}`
	}
	const response = await fetchWithBaseUrl(
		'authUser/productAndPayment' + query,
		{
			method: 'GET',
			headers: {
				'Content-Type': 'application/json',
				Authorization: 'Bearer ' + token,
			},
		}
	)
	if (response.ok) {
		const data = await response.json()
		setUserProductAndPaymentDTO(data)
	}
}
